<script lang="ts">
  import { Link } from "svelte-navigator";
  import Button from "../common/form/Button.svelte";
  import pageUrl from "../../PageUrl";
  export let isMobile: boolean;
</script>

<Link to={pageUrl.SIGNIN}>
  <div class:mobile={isMobile}>
    <Button tabIndex="-1">Sign In</Button>
  </div>
</Link>

<style lang="postcss">
  .mobile :global(button) {
    @apply px-4 py-1.5;
  }
</style>
